import mapImage from '@/assets/images/map.png';

export default function ContactPage() {
  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="py-36 bg-gradient-to-b from-[#0A1F1F] to-[#0D9488]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-4xl">
            <span className="text-sm font-medium text-[#5EEAD4] mb-4 block">문의</span>
            <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-8">
              Contact
            </h1>
            <p className="text-lg text-gray-200 leading-relaxed">
              프로젝트/시스템 구축 및 협업 문의는 아래 연락처로 부탁드립니다.
              <br />
              영업일 기준 1~2일 내 회신드립니다.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-36 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* 좌측: 문의 정보 */}
            <div className="max-w-xl">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">문의 정보</h2>

              <div className="space-y-8">
                {/* Email */}
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">이메일</h3>
                    <a
                      href="mailto:4lab@4-lab.com"
                      className="text-sm text-gray-600 hover:text-[#0D9488] transition-colors"
                    >
                      4lab@4-lab.com
                    </a>
                  </div>
                </div>

                {/* Tel */}
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">전화</h3>
                    <a
                      href="tel:02-881-5738"
                      className="text-sm text-gray-600 hover:text-[#0D9488] transition-colors"
                    >
                      02-881-5738
                    </a>
                  </div>
                </div>

                {/* Fax */}
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 flex-shrink-0">
                    <i className="ri-printer-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">팩스</h3>
                    <p className="text-sm text-gray-600">02-881-5739</p>
                  </div>
                </div>

                {/* Address */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">주소</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      경기도 하남시 미사대로 540, 6층 19호 (현대지식산업센터 한강미사2차(26BL))
                    </p>
                  </div>
                </div>

                {/* Response */}
                <div className="flex items-start">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#14B8A6]/10 mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl text-[#0D9488]"></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">응답 안내</h3>
                    <p className="text-sm text-gray-600">
                      문의 접수 후 영업일 기준 1~2일 내 회신드립니다.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="mt-12 p-8 bg-[#F0FDFA] rounded-lg border border-[#99F6E4]/30">
                <h3 className="text-lg font-bold text-gray-900 mb-3">빠른 상담</h3>
                <p className="text-sm text-gray-600 mb-5">
                  전화 또는 이메일로 연락주시면 빠르게 안내드리겠습니다.
                </p>

                <div className="flex flex-wrap gap-3">
                  <a
                    href="tel:02-881-5738"
                    className="inline-flex items-center px-5 h-10 bg-[#0D9488] text-white rounded-full text-sm font-medium hover:bg-[#0F766E] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    전화하기
                  </a>
                  <a
                    href="mailto:4lab@4-lab.com"
                    className="inline-flex items-center px-5 h-10 bg-white text-[#0D9488] border border-[#0D9488] rounded-full text-sm font-medium hover:bg-[#F0FDFA] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-mail-line mr-2"></i>
                    이메일 보내기
                  </a>
                </div>
              </div>
            </div>

            {/* 우측: 오시는 길 */}
            <div className="lg:pl-10">
              <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center lg:text-left">
                오시는 길
              </h2>

              <a
                href="https://kko.to/S1w-rlYy5_"
                target="_blank"
                rel="noreferrer"
                className="block rounded-lg overflow-hidden border border-gray-200 hover:border-gray-300 transition-colors bg-white"
              >
                <div className="w-full aspect-[16/10]">
                  <img
                    src={mapImage}
                    alt="4LAB 오시는 길 지도"
                    className="w-full h-full object-cover"
                  />
                </div>
              </a>

              <div className="mt-4 flex items-start gap-3 p-4 rounded-lg border border-gray-200 bg-white">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#14B8A6]/10 flex-shrink-0">
                  <i className="ri-information-line text-lg text-[#0D9488]"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-sm text-gray-800 font-medium">
                    지도를 클릭하면 길찾기로 이동합니다.
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    방문 전 연락주시면 주차/출입 안내를 도와드립니다.
                  </p>
                </div>
              </div>

              <div className="mt-6">
                <p className="text-sm font-bold text-gray-900 mb-2">주소</p>
                <p className="text-sm text-gray-600 leading-relaxed">
                  경기도 하남시 미사대로 540, 6층 19호 (현대지식산업센터 한강미사2차(26BL))
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
